import { API_URL } from "../../utils/contextHelpers";
import { api, buildQuery } from "./core";

export const actualizarEntrega = api("actualizarEntrega", (id, condicion) => `${API_URL}cotizacion/entrega?condicion=${condicion}&cotizacion=${id}`);

export const actualizarDespacho = api("actualizarDespacho", (id, cambia, comuna = null, direccion = null, referencia = null) => `${API_URL}cotizacion/despacho?${buildQuery({
    cambia: String(cambia),
    cotizacion: String(id),
    comuna,
    direccion,
    referencia,
})}`);

export const actualizarFlete = api("actualizarFlete", (id, valor) => `${API_URL}cotizacion/flete?id=${id}&valor=${valor}`);